import Repository from "@shared/services/api/abstracts/Repository";
import { PublicEventReviewSerializer } from "../types/events";

export default class PublicEventRatingsRepository extends Repository<PublicEventReviewSerializer> {
  public readonly repositoryName = "PublicEventRatingsRepository";

  public readonly endpoint = "api/public/events/ratings";
}
